import styled from 'styled-components';

export const ChartWrapper = styled.div`
  width: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  .chart-container {
    height: 100%;
    overflow: hidden;
  }
`;

export const ChartFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 5px;
`;
export const SourceText = styled.div`
  font-style: italic;
  color: #757575;
  font-size: 12px;
  padding: 5px 0px 0px 10px;
  background: #ffffff;
  width: 70%;
`;
export const DownloadButton = styled.div`
  margin-top: 10px;
  margin-right: 10px;
`;
